module.exports = __webpack_public_path__ + "static/media/headerbg.ba98f604.png";